import { createEvent } from '../../shared/utils/tracking.utils';

export const loadReportsEvent = createEvent('Loaded Latest Reports');
export const requestExtraAudit = createEvent('Requested Extra Audit');
export const changeLayout = createEvent('Changed Layout');
